var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgHands(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 50,
    height: 60,
    viewBox: "0 0 50 60",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M49.3151 27.2727C49.3151 42.4091 38.7945 56.5636 24.6575 60C10.5205 56.5636 0 42.4091 0 27.2727V10.9091L24.6575 0L49.3151 10.9091V27.2727ZM24.6575 54.5455C34.9315 51.8182 43.8356 39.6545 43.8356 27.8727V14.4545L24.6575 5.94545L5.47945 14.4545V27.8727C5.47945 39.6545 14.3836 51.8182 24.6575 54.5455ZM21.9178 33.2727H27.3973V41.4545H35.6164V27.8182H41.0959L24.6575 14.1818L8.21918 27.8182H13.6986V41.4545H21.9178V33.2727Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHands);
export default __webpack_public_path__ + "static/media/hands.3cfa13a1b3fc92612063cac916a358cc.svg";
export { ForwardRef as ReactComponent };